import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAccessToken } from "../../services/authSession";

const RequireAuth = () => {
  const location = useLocation();

  if (!getAccessToken()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default RequireAuth;

